<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">방제사전관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>방제명</p>
                <input type="text" placeholder="방제명을 입력하세요" class="form_control" v-model="searchInfo.dictionaryNm" @keyup.enter="fn_search">
              </li>
              <li>
                <p>출전</p>
                <input type="text" placeholder="출전을 입력하세요" class="form_control" v-model="searchInfo.dictionarySource" @keyup.enter="fn_search">
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <div class="table_option">
              <div class="form_select">
                <ul class="filter_kr">
                  <li v-for="(item, index) in filterKR" :key="index" 
                      :class="{ on:index === active}"
                      @click="active = index,fn_filter_click(index)"
                  >
                      {{ item }}
                  </li>
                </ul>
              </div>
              <div class="form_inline">
                <input type="file" ref="dictionaryExcelUpload" @change="fn_excel_read" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" hidden/>
                <button class="btn btn_md btn_outline"><i class="icon icon_excel" @click="fn_excel_upload_click"></i>Excel 업로드</button>
                <button class="btn btn_md btn_darkblue" @click="fn_move_reg_page">신규 등록</button>
              </div>              
            </div>
            <table class="list">
              <colgroup>
                <col width="300">
              </colgroup>
              <thead>
                <tr>
                    <th>방제코드</th>
                    <th>방제명</th>
                    <th>한자명</th>
                    <th>출전</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="dictionaryList.length == 0">
                    <td colspan="4"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in dictionaryList" :key="index" @click="fn_move_dtl_page(item.dictionary_cd)">
                  <td><span>{{ item.dictionary_cd }}</span></td>
                  <td class="al"><span>{{ item.dictionary_nm }}</span></td>
                  <td><span>{{ item.dictionary_chinese_nm }}</span></td>
                  <td><span>{{ item.dictionary_source }}</span></td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo="searchInfo.pageInfo"  @clickPage="fn_movePage" v-show="pagingShow"/>
          </div>
        </section>
      </div>

    </div>
</template>

<script>

    import axios from 'axios'
    import commonUtil from "@/mixin/commonUtil";
    import Pagination from "@/components/AdminPagination.vue"
    import { read, utils } from 'xlsx'

  export default {
    name: 'DictionaryMngt',
    components: {
      Pagination,
    },
    mixins: [commonUtil],
    data() {
      return {
        searchInfo : {
            dictionaryNm : '',
            dictionarySource : '',
            filterIndex : '',            
            pageInfo : {
                page : 1,
                pageSize : 10,
                totPage : 0
            }              
        },
        pagingShow : false,
        dictionaryList: [],
        selected: null,
        active: 0,
        filterKR:['전체','ㄱ','ㄴ','ㄷ','ㄹ','ㅁ','ㅂ','ㅅ','ㅇ','ㅈ','ㅊ','ㅋ','ㅌ','ㅍ','ㅎ']
      }
    },
    async created(){
          let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             
          if(searchInfoStore != null && searchInfoStore != {}){
              this.searchInfo = searchInfoStore
              this.active = this.searchInfo.filterIndex;
          }
        },
    mounted(){          
        this.fn_search();
    },
    methods : {
      fn_search(){
          console.log("@@@ search : ",this.searchInfo);

          this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo); 

          axios
              .post("/api/admin/dictionary/getDictionary", this.searchInfo)
              .then((res) => {
                  console.log("@@@@ res : %o",res);
                  this.dictionaryList = res.data.dictionaryList;

                  console.log("@@@@ dictionaryList : %o",this.dictionaryList);

                  this.searchInfo.pageInfo.totPage = res.data.totCnt;
                  
                  if(this.searchInfo.pageInfo.totPage> 0){
                      this.pagingShow = true;                          
                  }                        

              })
              .catch((err) => console.log(err));
      },
      fn_move_reg_page(){
          this.$store.dispatch('dictionary/setDictionaryCd', '');
          this.$router.push("/admin/dictionary/dictionaryMngtReg");
      },
      fn_filter_click(idx){
        this.searchInfo.filterIndex = idx;
        console.log("@@@@ this.filterIndex : "+this.searchInfo.filterIndex);
        this.fn_search();
      },
      fn_move_dtl_page(code){
            console.log("@@@@ dictionaryCd : "+code);
            this.$store.dispatch('dictionary/setDictionaryCd', code); 
            this.$router.push({ name : 'DictionaryMngtDtl'});
      },
      fn_excel_upload_click(){
          let fileInputElement = this.$refs.dictionaryExcelUpload;
          fileInputElement.click();
      },
      fn_excel_read(event){
        console.log("@@@@@ fn_excel_read ");

        const file = event.target.files[0];
        let reader = new FileReader();
        
        reader.onload = (e) => {
            
            let data = reader.result;
            

            //type 종류: 'base64' | 'binary' | 'buffer' | 'file' | 'array' | 'string';
            const workbook = read(data, {type: 'binary'});

            workbook.SheetNames.forEach(sheetName  => {
              console.log("@@@@@ sheetName : %o",sheetName);

              if(sheetName == "방제사전"){        
                
                   console.log("@@@@@ 방제사전~");

                  workbook.Sheets[sheetName].A1.w = "excel_upload_prescribe_cd";
                  workbook.Sheets[sheetName].B1.w = "dictionary_nm";
                  workbook.Sheets[sheetName].C1.w = "dictionary_source";
                  workbook.Sheets[sheetName].D1.w = "dictionary_note1";
                  workbook.Sheets[sheetName].E1.w = "dictionary_note2";
                  
                  const roa = utils.sheet_to_json(workbook.Sheets[sheetName]);                       
                  
                  this.fn_excel_dictionary_upload(roa);         

              }else if(sheetName == "방제사전약재"){

                  console.log("@@@@@ 방제사전약재~");

                  workbook.Sheets[sheetName].A1.w = "excel_upload_prescribe_cd";
                  workbook.Sheets[sheetName].B1.w = "med_hrb_dtl_nm";
                  workbook.Sheets[sheetName].C1.w = "med_use_qnty";
                  workbook.Sheets[sheetName].D1.w = "med_hrb_dtl_seq";
          
                  const roa = utils.sheet_to_json(workbook.Sheets[sheetName]);   
                  
                  console.log("@@@@@ roa : %o",roa);
                  
                  this.fn_excel_dictinary_med_upload(roa);  
              }
            });

            
                            
        };
        
        reader.readAsBinaryString(file);
        
      },
      fn_excel_dictionary_upload(uploadData){
        console.log("@@@@@ fn_excel_med_upload : %o",uploadData);

        axios
          .post("/api/admin/dictionary/excelDictionaryUpload", uploadData)
          .then((res) => {
              // alert("삭제되었습니다");
              // this.fn_dtl_search(medHrbCd);              
          })
          .catch((err) => console.log(err));


          this.$refs.dictionaryExcelUpload.values = {};

      },
      fn_excel_dictinary_med_upload(uploadData){

        console.log("@@@@@ fn_excel_dictinary_med_upload : %o",uploadData);

        axios
          .post("/api/admin/dictionary/excelDictionaryMedUpload", uploadData)
          .then((res) => {
              // alert("삭제되었습니다");
              // this.fn_dtl_search(medHrbCd);
          })
          .catch((err) => console.log(err));

        this.$refs.dictionaryExcelUpload = null;

      },
      fn_movePage(page){
        this.searchInfo.pageInfo.page = page;
        this.fn_search();
      },
    },
  }
</script>